import "@mui/material/styles";
import { Layout } from "antd";
import Sider from "antd/lib/layout/Sider";
import React, { lazy, useContext, useEffect, useState } from "react";
import { Route, BrowserRouter as Router, Routes, useParams } from "react-router-dom";
import DamnPage from "../src/components/DamnPage/damnPage.tsx";
import ProcoreIntegrationSuccess from "../src/components/Integrations/Procore/ProcoreIntegrationSuccess";
import PromptOnLink from "../src/components/MagicLinks/promptOnLink";
import ExecutiveCommandContainer from "../src/components/Team/ExecutiveCommand/ExecutiveCommandContainer.tsx";
import EulaAcceptModal from "../src/components/UI/EulaAcceptModal";
import GlobalStoreContext from "../src/context/GlobalStoreContext";
import PageContentType from "../src/PageContentType";
import PlotAPI from "../src/plotAPI";
import "./App.css";
import GlobalTheme from "./globalTheme";
import ProjectView from "./ProjectView";

const ChecklistContainer = lazy(
    () => import("../src/components/Materials/Views/Checklists/procurementChecklistContainer.tsx")
);
const FireTVConnect = lazy(() => import("../src/components/FireTVConnect/fireTVConnect"));
const Sidebar = lazy(() => import("../src/components/Sidebar/sidebar"));
const TeamPage = lazy(() => import("../src/views/teamPage"));

const App: React.FC<any> = () => {
    const [mobile, setMobile] = useState(false);
    const [showEulaModal, setShowEulaModal] = useState(false);
    const globalStoreContext = useContext(GlobalStoreContext);

    useEffect(() => {
        PlotAPI.getCurrentUserInfo().then((response) => {
            if (response) {
                if (!response.accepted_eula) {
                    // Return if the current url ends in  or `/code`
                    if (window.location.href.endsWith("/code")) {
                        return;
                    }

                    // Show a modal making them click a button to accept the EULA, link to the EULA
                    // Create state this is "showEulaModal" and set it to true
                    setShowEulaModal(true);
                }
            }
        });
    }, []);

    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get("mobile") && mobile == false) {
        if (urlParams.get("mobile") == "true") {
            setMobile(true);
        }
    }

    return (
        <>
            <GlobalTheme>
                <Layout hasSider={true}>
                    <PromptOnLink />

                    {
                        // TODO: Do we really want mobile to have sidebar but not desktop for this?

                        !window.location.href.includes("/executive-command") &&
                            !window.location.href.endsWith("/code") && (
                                <Sider
                                    trigger={null}
                                    collapsible
                                    collapsedWidth={globalStoreContext.isMobile ? 0 : 80}
                                    collapsed={globalStoreContext.collapseSidebar}
                                    onCollapse={(e) => {
                                        globalStoreContext.setCollapseSidebar(e);
                                    }}
                                    onBreakpoint={(e) => {
                                        globalStoreContext.setCollapseSidebar(e);
                                    }}
                                    breakpoint="lg"
                                >
                                    <Sidebar />
                                </Sider>
                            )
                    }
                    {
                        // NOTE: If you add or remove routes from this file you
                        // should also update the `routes.rb` file to match so
                        // that the Rails server will render the React app for
                        // those routes. */
                    }
                    <Layout>
                        <Router>
                            <Routes>
                                <Route path="/" element={<TeamView />} />
                                <Route path="/code" element={<FireTVConnectView />} />
                                <Route path="/profile" element={<TeamView page={"profile"} />} />
                                <Route path="/members" element={<TeamView page={"members"} />} />
                                <Route path="/events" element={<TeamView page={"events"} />} />
                                <Route path="/procurement" element={<TeamView page={"lead_times"} />} />
                                <Route path="/executive-command" element={<ExecutiveCommandContainer />} />
                                <Route path="/projects/:unique_token" element={<ProjectView />} />
                                <Route
                                    path="/projects/:unique_token/portal"
                                    element={<ProjectView page={"portal"} />}
                                />

                                <Route
                                    path="/projects/:unique_token/logistics"
                                    element={<ProjectView page={"logistics"} />}
                                />
                                <Route
                                    path="/projects/:unique_token/logistics/map/:object_id"
                                    element={<ProjectView page={"logistics"} />}
                                />
                                <Route
                                    path="/projects/:unique_token/events"
                                    element={<ProjectView page={"events"} />}
                                />
                                <Route
                                    path="/projects/:unique_token/events/:event_id"
                                    element={<ProjectView page={"events"} />}
                                />
                                <Route
                                    path="/projects/:unique_token/directory"
                                    element={<ProjectView page={"directory"} />}
                                />

                                <Route
                                    path="/projects/:unique_token/lead_times"
                                    element={<ProjectView page={"lead_times"} />}
                                />
                                <Route
                                    path="/projects/:unique_token/procurement/"
                                    element={<ProjectView page={"lead_times"} />}
                                />
                                <Route path="/projects/:unique_token/checklist" element={<ChecklistView />} />

                                <Route path="/event/:unique_token" element={<DamnPageView />} />

                                <Route path="/integrations/procore/success" element={<ProcoreIntegrationSuccess />} />
                                <Route path="/integrations/autodesk-build/success" element={<></>} />
                                <Route path="/integrations/autodesk-build/failure" element={<></>} />
                            </Routes>
                        </Router>
                    </Layout>
                </Layout>
            </GlobalTheme>
            <EulaAcceptModal showEulaModal={showEulaModal} setShowEulaModal={setShowEulaModal} />
        </>
    );
};

function FireTVConnectView() {
    return (
        <>
            <FireTVConnect />
        </>
    );
}

function TeamView(props: { page?: string }) {
    const globalStoreContext = useContext(GlobalStoreContext);

    useEffect(() => {
        globalStoreContext.setPageContentType(PageContentType.TEAM);
    }, []);

    return (
        <>
            <TeamPage page={props.page} />
        </>
    );
}

function DamnPageView() {
    const { unique_token } = useParams();

    const globalStoreContext = useContext(GlobalStoreContext);

    useEffect(() => {
        globalStoreContext.setPageContentType(PageContentType.DELIVERY);
    }, []);

    return (
        <>
            <DamnPage delivery_token={unique_token} />
        </>
    );
}

function ChecklistView() {
    const { unique_token } = useParams();
    const globalStoreContext = useContext(GlobalStoreContext);

    useEffect(() => {
        globalStoreContext.setPageContentType(PageContentType.CHECKLIST);
    }, []);

    return <ChecklistContainer unique_token={unique_token} />;
}

export default App;
